import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Carousel from '../../components/carousel/Carousel';
import { SwiperSlide } from "swiper/react";
import { BiEnvelope, BiLoader } from "react-icons/bi";
import { makeRequest } from '../../utils/makeRequest';
import toastNotify from '../../utils/toastNotify';
import * as urls from "../../utils/urlConst";
import { exceptionLog } from '../../utils/common';
import { getNotificationAlerts } from '../../apiService/apiService';

interface popup {
    isPopupMdl: boolean,
    setPopupMdl: React.Dispatch<React.SetStateAction<boolean>>,
    setShowPopup: React.Dispatch<React.SetStateAction<boolean>>,
    popupData: any[],
}

const Popup: React.FC<popup> = ({ isPopupMdl, setPopupMdl, popupData, setShowPopup, }) => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [ismarkasRead, setMarkasRead] = useState<boolean[]>(Array(popupData.length).fill(false));
    const [swiper, setSwiper] = useState<any>(null);

    const updatePopup = () => {
        window.localStorage.setItem("pop-up-announcement", JSON.stringify(false));
        setPopupMdl(false);
        setShowPopup(false);
    }

    const activeSlide = popupData.filter((data, id) => id === swiper);
    const getReadAnnouncement = ismarkasRead.filter((data, id) => id === swiper);

    const MaskasReadAnnouncement = async () => {
        try {
            setIsLoader(true);
            const payload = {
                TranCode: activeSlide.length !== 0 ? activeSlide[0]?.TranCode : popupData[0]?.TranCode,
                Type: "A"
            };
            const config = {};
            await makeRequest('POST', urls.readAnnouncementAlert, payload, config).then(async (result) => {
                if (result.STATUS === '0') {
                    await getNotificationAlerts();

                    const updateReadStatus = [...ismarkasRead];
                    if (activeSlide.length !== 0) {
                        updateReadStatus[swiper] = true;
                        setMarkasRead(updateReadStatus);
                    } else {
                        updateReadStatus[0] = true;
                        setMarkasRead(updateReadStatus);
                    }
                } else {
                    result.MESSAGE !== "No Data Found" && toastNotify(result.MESSAGE, 'error');
                };
            })
        } catch (error: any) {
            if (error.status !== 403) {
                await exceptionLog(error, "Get circular", "N");
            }
        } finally {
            setIsLoader(false);
        }
    };

    useEffect(() => {
        if (popupData.length !== 0) {
            if (ismarkasRead.filter((data: any) => data === true).length === popupData.length) {
                window.localStorage.setItem("pop-up-announcement", JSON.stringify(false));
                setPopupMdl(false);
                setShowPopup(false);
            }
        }
    }, [ismarkasRead])

    return (
        <div>
            <Modal
                show={isPopupMdl}
                backdrop="static"
                keyboard={false}
                size='lg'
            >
                <Carousel
                    pagination={true}
                    navigation={false}
                    className="main-caro"
                    autoplay={{
                        delay: 2500,
                        pauseOnMouseEnter: true,
                    }}
                    onSlideChange={(data: any) => setSwiper(data.activeIndex)}
                >
                    {popupData.map((items: any, id: number) => {
                        return (
                            <SwiperSlide key={id} className='Pop-up' style={{ height: "82vh", overflow: "auto" }}>
                                <Modal.Header>
                                    <Modal.Title className='text-base text-center w-100'>{items.Title}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className='ql-editor'>
                                        <div dangerouslySetInnerHTML={{ __html: items.Description }} />
                                    </div>
                                </Modal.Body>
                            </SwiperSlide>
                        )
                    })}
                </Carousel>

                <Modal.Footer>
                    {!getReadAnnouncement[0] &&
                        <Button variant={!getReadAnnouncement[0] ? "orange" : "secondary"} type='submit' className='btn-sm' onClick={() => MaskasReadAnnouncement()}>
                            {!isLoader ? <> <BiEnvelope className="me-2" /> Mark as read</> : <><BiLoader className='icon-loader text-lg' /> Loading...</>}
                        </Button>
                    }
                    <Button variant="outline-orange" onClick={updatePopup} className='btn-sm'>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Popup
